export default __webpack_public_path__ + "static/media/ra-profile.d99d3f7b.jpg";